module.exports = __webpack_public_path__ + "img/eductor_driving.4d77a419.svg";